import { Box, Skeleton, Stack } from "@mui/material"
import { FC } from "react"
import { useAppSelector } from "../app/hooks"
import { selectMeIsReady } from "../features/me/meSlice"
import { selectDatasetByName } from "../features/report/reportSlice"
import OsReportingPaymentMethodSummary from "./OsReportingPaymentMethodSummary"
import OsReportingPaymentSummary from "./OsReportingPaymentSummary"

type OsReportingPaymentProps = {
  isLoading: boolean
}
export const OsReportingPayment: FC<OsReportingPaymentProps> = ({
  isLoading,
}) => {
  const isReady = useAppSelector(selectMeIsReady)

  const paymentSummary = useAppSelector(selectDatasetByName("paymentSummary"))

  const paymentMethodSummary = useAppSelector(
    selectDatasetByName("paymentMethodSummary"),
  )

  return (
    <>
      {!isReady && (
        <>
          <Stack direction="column" spacing={2}>
            <Skeleton variant="rectangular" width="100%" height={118} />
            <Skeleton variant="rectangular" width="100%" height={118 / 2} />
            <Skeleton variant="rectangular" width="100%" height={118} />
            <Skeleton variant="rectangular" width="100%" height={118 / 2} />
          </Stack>
        </>
      )}
      {isReady && (
        <Stack direction={"column"} spacing={4}>
          <Stack direction="row" spacing={1}>
            <Box>
              <OsReportingPaymentSummary
                ds={paymentSummary}
                isLoading={isLoading}
              />
            </Box>
            <Box>
              <OsReportingPaymentMethodSummary
                ds={paymentMethodSummary}
                isLoading={isLoading}
              />
            </Box>
          </Stack>
          {/* <OsReportingPaymentReservations /> */}
        </Stack>
      )}
    </>
  )
}

export default OsReportingPayment
